define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare, _, PathMatrix, xml) {

	return declare(PathMatrix, {
		// path from view node to columns
		columnPath : "Child:Themes/Child:ThemeSeasons",

		_filterNodes : function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: filter nodes by row ColorSpecification and column Season
			var urlSeason = spec.columnUrl;

			// filter the MaterialPlanPlacement nodes by seasons from the theme && main material = true
			return _.filter(nodes, function(node) {
				if(node.MainMaterial) {
					var theme = ctx.cache.getNode(node.__Parent__);
					return theme ? _.indexOf(theme.ThemeSeasons, urlSeason) !== -1: false;
				}
				return false;
			});
		}
	});
});